import React, { MouseEvent } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import posed from 'react-pose';
import { themes } from 'kb-shared';

export const LastPeriod = (props: {
  date: string;
  pose: string;
  editVisible: boolean;
  onEditPress: (e: MouseEvent) => VoidFunction;
}) => {
  return (
    <LastPeriodContainer pose={props.pose}>
      <YellowContainer>
        <LastPeriodText>Last Period</LastPeriodText>
        <LastPeriodDate>{moment(props.date).format('MMM D')}</LastPeriodDate>
      </YellowContainer>
      {props.editVisible ? <EditButton onClick={props.onEditPress}>Edit</EditButton> : null}
    </LastPeriodContainer>
  );
};

export const CycleLength = (props: {
  pose: string;
  daysBetweenCycles: number | null;
  editVisible: boolean;
  onEditPress: (e: MouseEvent) => void;
}) => {
  return (
    <CycleLengthContainer pose={props.pose}>
      <YellowContainer>
        <CycleLengthText>Cycle Length</CycleLengthText>
        <CycleLengthDate>{props.daysBetweenCycles} days</CycleLengthDate>
      </YellowContainer>
      {props.editVisible ? <EditButton onClick={props.onEditPress}>Edit</EditButton> : null}
    </CycleLengthContainer>
  );
};

const ANIMATION_DURATION = 300;
const AnimatedContainer = posed.div({
  show: {
    height: '26px',
    flip: true,
    transition: { duration: ANIMATION_DURATION }
  },
  close: { height: '0px', transition: { duration: ANIMATION_DURATION } }
});

const LastPeriodContainer = styled(AnimatedContainer)`
  margin-bottom: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;
const CycleLengthContainer = LastPeriodContainer;
const YellowContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: ${themes.colors.yellow};
  min-width: 160px;
  padding: 4px 12px;
  margin-left: 40px;
`;
const LastPeriodText = styled.span`
  ${themes.fonts.FoundersGrotesk};
  font-size: 14px;
  padding-right: 5px;
  text-transform: uppercase;
  white-space: nowrap;
`;
const CycleLengthText = LastPeriodText;
const LastPeriodDate = styled(LastPeriodText)`
  font-weight: bold;
`;
const CycleLengthDate = styled(CycleLengthText)`
  font-weight: bold;
`;
const EditButton = styled.a`
  right: 0px;
  text-decoration: underline;
  ${themes.fonts.FoundersGrotesk};
  font-size: 14px;
  font-weight: bold;
  margin-left: 16px;
`;
